





























































































































































































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import {
  DppFinal, Encaminhamento, SexoBebe, TipoParto,
} from '../../../../back/src/types';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { sexoBebeStrings, tipoPartoStrings, avisosGestacao } from '../../utils/constants';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { calculoIdadeGestacional, montaFlagsAarray, ocorrenciasPartoString } from '../../utils/functions';
import { Parto } from '../../../../back/src/entity/Parto';
import GestacoesFinalizarForm from './GestacoesFinalizarForm.vue';

export default Vue.extend({
  name: 'TheGestacoesDadosFinalizada',
  components: {
    IfEmptyTextPrintNA,
    GestacoesFinalizarForm,
  },
  props: {
    gestacao: {
      type: Object as () => Gestacao,
      required: true,
    },
    paciente: {
      type: Object as () => Paciente,
      required: true,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TipoParto,
      editarGestacao: false,
    };
  },
  computed: {
    idadeGestacional(): string {
      if (this.gestacao.gestacao_anterior) {
        if (!this.gestacao.ig_semanas) return '';
        return `${this.gestacao.ig_semanas} ${this.gestacao.ig_dias ? `${this.gestacao.ig_dias}/7` : ''} semanas`;
      }
      return calculoIdadeGestacional(this.gestacao, this.gestacao.data_parto, true);
    },
    igAborto() {
      if (this.gestacao && this.gestacao.parto && this.gestacao.parto.ig_aborto_semanas) {
        return `${this.gestacao.parto.ig_aborto_semanas} semanas`;
      }
      return null;
    },
    contatoPeleRn1() {
      if (this.gestacao && this.gestacao.parto && this.gestacao.parto.contato_pele1 !== null) {
        return this.gestacao.parto.contato_pele1 ? 'Sim' : `Não - ${this.gestacao.parto.contato_pele1_justificativa}`;
      }
      return null;
    },
    contatoPeleRn2() {
      if (this.gestacao && this.gestacao.parto && this.gestacao.parto.contato_pele2 !== null) {
        return this.gestacao.parto.contato_pele2 ? 'Sim' : `Não - ${this.gestacao.parto.contato_pele2_justificativa}`;
      }
      return null;
    },
    dppFinalLabel(): string {
      if (this.gestacao.dpp_final === DppFinal.M) {
        return '(a partir da DUM)';
      }
      if (this.gestacao.dpp_final === DppFinal.U) {
        return '(US)';
      }
      return '';
    },
    dppFinal(): string {
      if (this.gestacao.dpp_final === DppFinal.M) {
        if (!this.gestacao.data_ultima_menstruacao) {
          return '';
        }
        const momentDate = moment(this.gestacao.data_ultima_menstruacao).add(40, 'w');
        if (!momentDate.isValid()) {
          return 'DPP inválida';
        }
        return momentDate.utc().format('DD/MM/YYYY');
      }
      if (this.gestacao.dpp_final === DppFinal.U) {
        if (!this.gestacao.data_provavel_parto_us) {
          return '';
        }
        const momentDate = moment(this.gestacao.data_provavel_parto_us);
        if (!momentDate.isValid()) {
          return 'DPP inválida';
        }
        return momentDate.utc().format('DD/MM/YYYY');
      }
      return '';
    },
    dataUltimaMenstruacaoFormatada(): string {
      const momentDate = moment(this.gestacao.data_ultima_menstruacao);
      if (momentDate.isValid()) {
        return momentDate.utc().format('DD/MM/YYYY');
      }
      return '';
    },
    dataExameUsFormatada(): string {
      const momentDate = moment(this.gestacao.data_exame_us);
      if (momentDate.isValid()) {
        return momentDate.utc().format('DD/MM/YYYY');
      }
      return '';
    },
    igExameUs(): string {
      if (this.gestacao.ig_exame_us_dias) {
        return `
          ${Math.floor(this.gestacao.ig_exame_us_dias / 7)}
          ${this.gestacao.ig_exame_us_dias % 7}/7
        `;
      }
      return '';
    },
    dataExameUsLaudo(): string {
      if (this.dataExameUsFormatada) {
        return `${this.dataExameUsFormatada} - IG ${this.igExameUs}`;
      }
      return '';
    },
    dataProvavelPartoUsFormatada(): string {
      const momentDate = moment(this.gestacao.data_provavel_parto_us);
      if (momentDate.isValid()) {
        return momentDate.utc().format('DD/MM/YYYY');
      }
      return '';
    },
    alturaCm(): string {
      if (this.paciente.altura_cm) {
        const alturaCm = this.paciente.altura_cm / 100;
        return `${new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(alturaCm)} m`;
      }
      return '';
    },
    pesoInicialKg(): string {
      if (this.gestacao.peso_inicial_gramas) {
        const pesoInicialKg = this.gestacao.peso_inicial_gramas / 1000;
        return `${new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 1,
        }).format(pesoInicialKg)} kg`;
      }
      return '';
    },
    gestacaoGemelarObs(): string {
      if (this.gestacao.gestacao_gemelar && this.gestacao.gestacao_gemelar_obs) {
        return ` (${this.gestacao.gestacao_gemelar_obs})`;
      }
      return '';
    },
    flags(): { sigla: string, descricao: string, color: string }[] {
      return montaFlagsAarray(this.gestacao);
    },
    apgarRn1() {
      if (!this.gestacao.parto || !this.gestacao.parto.apgar1_1) return null;
      let apgar: string = `${this.gestacao.parto.apgar1_1} | ${this.gestacao.parto.apgar1_2}`;
      if (this.gestacao.parto.apgar1_3) {
        apgar = `${apgar} | ${this.gestacao.parto.apgar1_3}`;
      }
      return apgar;
    },
    apgarRn2() {
      if (!this.gestacao.parto || !this.gestacao.parto.apgar2_1) return null;
      let apgar: string = `${this.gestacao.parto.apgar2_1} | ${this.gestacao.parto.apgar2_2}`;
      if (this.gestacao.parto.apgar2_3) {
        apgar = `${apgar} | ${this.gestacao.parto.apgar2_3}`;
      }
      return apgar;
    },
    encaminhamentoRn1() {
      if (!this.gestacao.parto || this.gestacao.parto.encaminhamento1 === null) return null;
      let enc: string = this.gestacao.parto.encaminhamento1;
      if (this.gestacao.parto.encaminhamento1 !== Encaminhamento.ALOJAMENTO_CONJUNTO) {
        enc = `${enc} - ${this.gestacao.parto.encaminhamento1_justificativa}`;
      }
      return enc;
    },
    encaminhamentoRn2() {
      if (!this.gestacao.parto || this.gestacao.parto.encaminhamento2 === null) return null;
      let enc: string = this.gestacao.parto.encaminhamento2;
      if (this.gestacao.parto.encaminhamento2 !== Encaminhamento.ALOJAMENTO_CONJUNTO) {
        enc = `${enc} - ${this.gestacao.parto.encaminhamento2_justificativa}`;
      }
      return enc;
    },
  },
  methods: {
    gestacaoFinalizadaAtualizada(gestacao: Gestacao) {
      this.$emit('gestacao-finalizada-atualizada', gestacao);
      this.editarGestacao = false;
    },
    laceracaoSutura(parto: Parto): string {
      const laceracao = parto.laceracao === 0 ? 0 : parto.laceracao || -1;
      if (laceracao > 0) {
        return `${laceracao}° ${parto.sutura ? 'C' : 'S'}S`;
      } if (laceracao === 0) {
        return 'PI';
      }
      return '';
    },
    ocorrenciasParto(parto: Parto) {
      return ocorrenciasPartoString(parto);
    },
    sexoBebe(sexoBebe: SexoBebe): string {
      if (_.has(sexoBebeStrings, sexoBebe)) {
        return sexoBebeStrings[sexoBebe];
      }
      return '';
    },
    tipoPartoString(tipoParto: TipoParto) {
      if (_.has(tipoPartoStrings, tipoParto)) {
        return tipoPartoStrings[tipoParto];
      }
      return '';
    },
    pesoFormatado(pesoGramas: number): string {
      if (pesoGramas) {
        return `${new Intl.NumberFormat('pt-BR').format(pesoGramas)} g`;
      }
      return '';
    },
  },
});
